import { z } from "zod"

export const MessengerAuthorizeSchema = z.object({
  code: z.string(),
})

export const MessengerIntegrationParams = z.object({
  id: z.string().transform(BigInt),
})
